export default "__VITE_ASSET__BtWIfHxs__"